import VideoPlayer from './VideoPlayer/VideoPlayer';
import CustomButton from './CustomButton/CustomButton';

const InsideBrandAcumen = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 

  return (
    <section className="py-5 text-center">
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h2 className="font-bold text-black">INSIDE BRAND ACUMEN</h2>
          </div>
        </div>

        {/* Image */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-10 px-4 px-md-0 pb-5  ">
            <VideoPlayer
              videoSrc={`${awsImageBaseUrl}video/MAIN_VIDEO_FINAL.mp4`}
              posterSrc={`${awsImageBaseUrl}images/poster.png`}
            />
          </div>
        </div>

        {/* Subheading */}
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h3 className="font-bold text-black text-uppercase pt-5">
              Branding Redefined
            </h3>
          </div>
        </div>

        {/* Paragraph */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <p>
              Brand Acumen’s innovative approach to brand naming is fueled by global linguistic analysis and in-depth market research. We’ve created iconic names for some of the world’s biggest companies. We’re ready to do the same for you.
            </p>
          </div>
        </div>

        {/* Button */}
        <div className="row justify-content-center">
          <div className="col-auto">
            <CustomButton
              label="WHAT WE DO"
              variant="red"
              size="small"
              href="/what-we-do"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsideBrandAcumen;
